<template>
  <div>
    <div class="modal-header">
      <h4 class="modal-title max-lg:hidden">Connexion</h4>
      <FormTitle view="login" class="lg:hidden" />
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <div v-if="authError" class="notification notification-danger" role="alert">
        <div class="notification-content">
          <div class="notification-text">
            L'identifiant n'est pas valide. Pour vous inscrire
            <a href="/signup">cliquez ici</a>
            .
          </div>
        </div>
      </div>
      <form novalidate="novalidate" @submit="login">
        <div class="form-group">
          <input
            id="user_email"
            v-model="user.email"
            type="text"
            placeholder="Adresse email ou nom d'utilisateur"
            name="user_email"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <input
            id="user_password"
            v-model="user.password"
            type="password"
            placeholder="Mot de passe"
            autocomplete="current-password"
            name="user_password"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <div class="checkbox">
            <input type="hidden" name="user_remember_me" value="0" />
            <label for="user_remember_me">
              <input
                id="user_remember_me"
                v-model="user.remember_me"
                type="checkbox"
                name="user_remember_me"
                class="mr-2 mt-1"
              />
              <span>Se souvenir de moi</span>
            </label>
          </div>
        </div>
        <vue-ladda type="submit" class="btn btn-primary btn-block" :loading="loading">Connexion</vue-ladda>
      </form>
    </div>
  </div>
</template>

<script>
import { useApi } from '@/apps/shared/composables'
import FormTitle from './FormTitle.vue'

export default {
  components: {
    FormTitle
  },
  data() {
    return {
      loading: false,
      user: {
        email: '',
        password: '',
        remember_me: true
      },
      authError: null
    }
  },
  methods: {
    login(e) {
      e.preventDefault()
      this.loading = true
      this.authError = false
      useApi().post('/login', { user: this.user }).then(this.successCallback, this.errorCallback)
    },
    successCallback(data) {
      this.loading = false
      window.location.reload()
    },
    errorCallback(error) {
      console.error(error)
      this.loading = false
      this.authError = true
    }
  }
}
</script>
